import React, { ReactNode } from 'react'
import { stopPropagation } from './key-handlers'

interface LabelBase {
  label: string
  value: any
  className?: string
  id?: string
  isReadOnly?: boolean
  onBlur?: any
  onChange?: any
  onClick?: any
  onKeyDown?: any
  onRef?: any
  onFocus?: any
}

interface TextInputWithLabelType extends LabelBase {
  rightLabel?: string
  isAutoFocus?: boolean
  placeholder?: string
}

interface CheckboxWithLabelType extends LabelBase {
  // disabled?: boolean
}

interface ImageWithLabelType extends LabelBase {
  src: string
  onImageRef: any
}

interface DivWithLabelType extends LabelBase {
  className: string
  children?: ReactNode
  rightLabel?: string
}
export type SelectOptions = { value: string; name: string }[]
interface SelectWithLabelType extends LabelBase {
  itemArray: SelectOptions
}

const TextInputWithLabel = ({
  id,
  className,
  label,
  rightLabel,
  isReadOnly,
  onBlur,
  onChange,
  onClick,
  onKeyDown = stopPropagation,
  value,
  onRef,
  onFocus,
  placeholder,
}: TextInputWithLabelType) => {
  return (
    <div onClick={onClick}>
      {<label htmlFor={id}>{label ? `${label}: ` : ''}</label>}
      <input
        id={id}
        ref={onRef}
        className={className}
        type="text"
        readOnly={isReadOnly}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
        defaultValue={value}
        onFocus={onFocus}
        placeholder={placeholder}
      />
      {<label htmlFor={id}>{rightLabel} </label>}
    </div>
  )
}
const ControlledTextInputWithLabel = ({
  id,
  label,
  rightLabel,
  placeholder,
  isReadOnly,
  onBlur,
  onChange,
  onKeyDown = stopPropagation,
  value,
  onRef,
  isAutoFocus,
}: TextInputWithLabelType) => {
  return (
    <div>
      {<label htmlFor={id}>{label ? `${label}: ` : ''}</label>}
      <input
        id={id}
        ref={onRef}
        className="textInputWithLabel"
        type="text"
        readOnly={isReadOnly}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={value}
        autoFocus={isAutoFocus}
        placeholder={placeholder}
      />
      {<label htmlFor={id}>{rightLabel} </label>}
    </div>
  )
}

const CheckboxWithLabel = ({
  id,
  label,
  isReadOnly,
  value,
  onChange,
  onRef,
}: CheckboxWithLabelType) => {
  return (
    <div className="labeledCheckbox">
      <input
        type="checkbox"
        ref={onRef}
        id={id}
        defaultChecked={!!value}
        disabled={isReadOnly}
        onChange={onChange}
      />
      <label htmlFor={id} className="handle">
        {label}
      </label>
    </div>
  )
}

const ImageWithLabel = ({ id, label, src, onImageRef, onClick }: ImageWithLabelType) => {
  return (
    <div>
      <label htmlFor={id}>{label ? `${label}: ` : ''}</label>
      <img
        id={id}
        ref={onImageRef}
        className="imageWithLabel"
        alt={label}
        src={src}
        onClick={onClick}
      />
    </div>
  )
}

const DivWithLabel = ({ id, label, value, className, children, rightLabel }: DivWithLabelType) => {
  return (
    <div>
      <label htmlFor={id}>{label ? `${label}: ` : ''}</label>
      <div id={id} className={className}>
        {value || children}
      </div>
      {<label htmlFor={id}>{rightLabel} </label>}
    </div>
  )
}

const SelectWithLabel = ({
  id,
  label,
  itemArray,
  value: selectedItemValue,
  onChange,
  isReadOnly,
  onRef,
}: SelectWithLabelType) => {
  return (
    <div className="labeledSelect">
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        ref={onRef}
        defaultValue={selectedItemValue}
        onChange={onChange}
        disabled={isReadOnly}
      >
        {itemArray.map(({ value, name }) => (
          <option key={value} value={value}>
            {name !== undefined ? name : value}
          </option>
        ))}
      </select>
    </div>
  )
}

export {
  CheckboxWithLabel,
  ControlledTextInputWithLabel,
  DivWithLabel,
  ImageWithLabel,
  SelectWithLabel,
  TextInputWithLabel,
}
